<template>
  <div>
    <ul v-if="computedArr.length" class="product-card-characteristics" :class="{'product-card-characteristics--only-desktop': onlyDesktop}">
      <li v-for="(characteristic, index) in computedArr"
          :key="index"
          class="product-card-characteristics__item characteristic"
          :class="[size ? 'characteristic--' + size : '']">
        <span class="characteristic__name">{{ characteristic['name'] }}:</span>
        <span class="characteristic__value">{{ characteristic['value'] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ProductCardCharacteristics',
  props: {
    values: [Array, Object],
    size: {
      type: String,
      default: ''
    },
    onlyDesktop: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      initialOffset: state => state.productTabs.initialOffset
    }),
    computedArr () {
      if (Array.isArray(this.values)) {
        return this.values
      }
      return Object.values(this.values)[0] || []
    }
  },
  methods: {
    ...mapActions(['SET_ACTIVE_TAB']),
    setActiveTab () {
      const data = {
        string: 'characteristics',
        top: this.initialOffset - 50
      }
      this.SET_ACTIVE_TAB(data)
    }
  }
}
</script>

<style lang="sass">
.product-card
  .characteristic:not(:last-child)
    margin-bottom: 4px

    +mmin($tablet)
      margin-bottom: 6px
</style>
<style lang="sass" scoped>

.product-card-characteristics
  +list-unstyled

  &--only-desktop
    display: none
    +mmin(767)
      display: block

.characteristic
  color: $placeholder-color
  font-size: 12px
  line-height: 15px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-weight: 400

  &--medium
    font-size: 14px
    line-height: 17px
    font-weight: 400

.characteristic__name
  margin-right: 5px

.characteristic__value
  color: $text-color

.fake-link
  color: #3e77aa
  font-size: 14px
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  margin-top: 20px
  display: inline-block

</style>

<style lang="sass">
.tab-description__row
  .product-card-characteristics
    margin-bottom: 12px
    &__item
      display: flex
      align-items: center
      padding: 10px 0
      border-bottom: 1px solid #E7E7E7
      &:first-child
        padding-top: 0
  .characteristic__name
    padding-right: 5px
    width: 60%
    flex-shrink: 0
    font-size: 14px
    line-height: 1.2
    color: #333333
  .characteristic__value
    width: 40%
    flex-shrink: 0
    font-size: 14px
    line-height: 1.2
    color: #333333
</style>
